import React from "react";

export default function ScrollToTop() {
  return <div></div>;
}
